import ExportedImage from "next-image-export-optimizer";
import { inject, observer } from "mobx-react";
import { Store } from "stores/store";
import { getAltTextFromGeneralImage, getImageUrlFromGeneralImage, getStrapiAssetUrl } from "utils/imageHelpers";
import { cn } from "@/lib/utils";
import Card from "@/components/shared/futureChat/cards/Card";
import ButtonChat from "@/components/shared/futureChat/buttons/ButtonChat";
import { useEffect, useState } from "react";
import Projection from "@/components/shared/projection/Projection";
import QrCode from "@/components/shared/QrCode/QrCode";


type SelfieProps = {
    store?: Store;
    onNewSelfie: () => void;
    onCancel: () => void;
    className?: string;
};

export const Selfie: React.FC<SelfieProps> = ({ store, onNewSelfie, onCancel, className }) => {

    if (!store) {
        throw Error("Component was not setup correctly");
    }

    const { selfieImageUrl, updateIsLoading, chatSteleLocalized, globalEventLocalized, imageAgedUrl, imagePresentUrl } = store;

    const [ready, setReady] = useState<Boolean>(false)
    const [finalSelfie, setFinalSelfie] = useState<string>("")

    async function shareGif(gifUrl: string) {
        try {
            const response = await fetch(gifUrl);
            const blob = await response.blob();
            const file = new File([blob], "aged.gif", { type: "image/gif" });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    files: [file],
                    title: "My Future Portrait",
                    text: "Check out what I might look like in the future 👵🧓",
                });
            } else {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "aged.gif";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error("Error while sharing GIF:", err);
        }
    }

    useEffect(() => {
        if (selfieImageUrl !== undefined && selfieImageUrl !== null) {
            setFinalSelfie(selfieImageUrl)
            setTimeout(() => {
                setReady(true)
            }, 750)
        }
    }, [selfieImageUrl])

    useEffect(() => {
        if (selfieImageUrl && ready) {
            updateIsLoading(false);
        }
    }, [ready])

    return (
        <>
            <div className={cn("scrollbar-hidden z-[9999999] fixed flex justify-center px-[16px] w-full h-full overflow-hidden", className)}>
                {globalEventLocalized?.selfieBackground !== undefined && globalEventLocalized?.selfieBackground !== null &&
                    <ExportedImage
                        src={getImageUrlFromGeneralImage(globalEventLocalized?.selfieBackground)}
                        alt={getAltTextFromGeneralImage(globalEventLocalized?.selfieBackground)}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                    />
                }
                <div className="relative flex flex-col justify-center items-center gap-[16px] pt-[20%] w-full 2xs:w-[364px] h-full">
                    <div className="flex">
                        <p className="font-frutigerBold text-[16px] text-center leading-[115%]">Zum speichern <br /> gedrückt halten</p>
                        <div className="right-0 absolute w-[36px] h-[36px]">
                            <ButtonChat
                                iconRight={
                                    <ExportedImage
                                        src={
                                            globalEventLocalized?.selfieModalButton2.icon !== undefined &&
                                                globalEventLocalized?.selfieModalButton2.icon !== null
                                                ? getImageUrlFromGeneralImage(globalEventLocalized?.selfieModalButton2.icon)
                                                : "No image provided"
                                        }
                                        alt={
                                            globalEventLocalized?.selfieModalButton2.icon !== undefined &&
                                                globalEventLocalized?.selfieModalButton2.icon !== null
                                                ? getAltTextFromGeneralImage(globalEventLocalized?.selfieModalButton2.icon)
                                                : "No image provided"
                                        }
                                        layout="fill"
                                    />
                                }
                                variant="primary"
                                onClick={onCancel}
                            >
                            </ButtonChat>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[8px] p-[8px] max-h-max">
                        <div className="flex justify-center items-center w-full h-full min-h-[340px]" >
                            {selfieImageUrl ?
                                <ExportedImage
                                    src={finalSelfie ?
                                        (finalSelfie)
                                        : process.env.NEXT_PUBLIC_BASE_PATH + "images/test/test_lena-cc.png"}
                                    alt={"imgOld"}
                                    fill={true}
                                    className="relative rounded-[9px]"
                                /> :
                                chatSteleLocalized?.loadingSpinner !== undefined &&
                                chatSteleLocalized?.loadingSpinner !== null && (
                                    <div className="relative w-[42px] h-[17px]">
                                        <ExportedImage
                                            src={getImageUrlFromGeneralImage(chatSteleLocalized?.loadingSpinner)}
                                            alt={getAltTextFromGeneralImage(chatSteleLocalized?.loadingSpinner)}
                                            layout="fill"
                                            objectFit="cover"
                                            objectPosition="center"
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="flex justify-center items-center gap-[8px] w-full">
                        <div className="max-w-min whitespace-nowrap">
                            <ButtonChat
                                variant="primary"
                                onClick={() => shareGif(finalSelfie)}
                            >
                                Teilen
                            </ButtonChat>
                        </div>
                        <div className="max-w-min whitespace-nowrap">
                            <ButtonChat

                                variant="primary"
                                onClick={onNewSelfie}
                            >
                                {globalEventLocalized?.selfieModalButton1.text}
                            </ButtonChat>
                        </div>
                    </div>

                </div>
            </div >

            <div className="opacity-0">
                <Projection />
            </div>
        </>
    );
};

export default inject("store")(observer(Selfie));
